import React, {useRef, useState} from 'react';
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {UseLoader} from "../../../../hooks/useLoader";
import {UsePermissions} from "../../../../hooks/usePermissions";
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {convertirModena} from "../../../../shared/utils/utils";
import {traerInformeCompensacion, traerInformeCompensacionAsociado} from "../../../../api/informes.service";
import {ModalDetalleInformeCompensacion} from "./ModalDetalleInformeCompensacion";

export const TablaInformeCompensacionEvento = ({factura, asociados, dataInicial, reload}) => {

    const toast = useRef(null);
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions();
    const [showDetail, setShowDetail] = useState(false);
    const [dataEvent, setDataEvent] = useState([]);

    const onDetail= async () => {
        try {
            handleLoad(true);
            const response = await traerInformeCompensacion({cliente_id: dataInicial.cliente_id, contratomarco_id:dataInicial.contratomarco_id ,anio: dataInicial.anio, mes: dataInicial.mes, periodo: dataInicial.periodo});
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }
            setDataEvent(response)
            setShowDetail(true);
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const onDetailAsociado= async (rowData) => {
        try {
            handleLoad(true);
            const response = await traerInformeCompensacionAsociado({
                asociado_id: rowData,
                cliente_id: dataInicial.cliente_id,
                anio: dataInicial.anio,
                mes: dataInicial.mes,
                periodo: dataInicial.periodo
            });
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }
            setDataEvent(response);
            setShowDetail(true);
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">
                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => onDetailAsociado(rowData.asociado_id)}>
                    <i className="fa fa-edit"/>
                </button>
            </div>
        );
    }

    const header = (
        <div className="flex align-items-center ">
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={onDetail}
                >
                    <i className="fa fa-address-book"/> Ver detalle
                </button>
            </div>
        </div>
    );

    const footer = (
        <div className="flex align-items-center  ">
            <p className={'p-2 text-sm text-teal-600 '}>
                Total Ingresos: {convertirModena(factura.sub_total_dos)}</p>

        </div>
    );


    let footerGroup=
        <ColumnGroup>
            <Row>
                <Column footer="" colSpan={2} footerStyle={{marginLefth: '5px'}}/>
                <Column footer={"Total Ingresos:"}/>
                <Column footer={convertirModena(factura.sub_total_dos)}/>
            </Row>
        </ColumnGroup>;

    const onHide = () => {
        setShowDetail(false);
        setDataEvent([]);
    }


    return(
        <>
            <Toast ref={toast}/>
            <DataTable
                showGridlines
                value={asociados}
                size="small"
                editMode="cell"
                dataKey="id"
                header={header}
                scrollable scrollHeight="400px"
                footerColumnGroup={footerGroup}
                responsiveLayout="scroll">
                <Column header="Detalle Asociado" style={{fontSize: ".8em", width: '5%'}} body={actionTemplate}/>
                <Column field="num_doc" filter sortable header="ID" style={{width: '10%'}}></Column>
                <Column field="nombres" filter sortable header="Afiliados" style={{width: '10%'}}></Column>
                <Column field="sub_total" filter sortable header="Ingresos" style={{width: '10%'}}></Column>
            </DataTable>

            <ModalDetalleInformeCompensacion show={showDetail} hide={onHide} fields={dataEvent}/>
        </>
    )

}
